import { Injectable } from '@angular/core';


@Injectable()
export class RenderSlugService {

  private slug: string = '';

  public setSlug(slug: string): void {
    this.slug = slug;
  }

  public getSlug(): string {
    return this.slug;
  }

}
